/**
 * F9: regras do tour, separadas do componente para teste. Review r2 (spec M6): o tour não apontava a primeira
 * ação (o slot do Início fica vazio) e no celular não mostrava nada (os alvos ficam no menu recolhido), então
 * nunca chegava ao fim e o onboarding se repetia a cada login.
 */
export interface PassoTour {
  chave: string;
  /** Alvos `data-tour` em ordem de preferência; o primeiro visível ganha o holofote. */
  alvos: string[];
  titulo: string;
  texto: string;
  /** O alvo mora no menu lateral: no celular, abre a gaveta antes de procurar. */
  noMenu?: boolean;
  /** Só entra se algum alvo existir na página (ex.: Admin depende de permissão). */
  opcional?: boolean;
}

export const PASSOS_TOUR: PassoTour[] = [
  { chave: 'menus', alvos: ['sidebar'], titulo: 'tour.sidebarTitulo', texto: 'tour.sidebarTexto', noMenu: true },
  { chave: 'workspace', alvos: ['workspace'], titulo: 'tour.workspaceTitulo', texto: 'tour.workspaceTexto', noMenu: true },
  // Primeira ação: o botão primário da tela, senão o atalho do primeiro módulo no Início, senão o item do menu.
  { chave: 'primeira-acao', alvos: ['acao-primaria', 'primeira-acao', 'primeiro-modulo'], titulo: 'tour.acaoTitulo', texto: 'tour.acaoTexto' },
  { chave: 'admin', alvos: ['menu-admin'], titulo: 'tour.adminTitulo', texto: 'tour.adminTexto', noMenu: true, opcional: true },
];

export interface DomTour {
  /** Existe em algum lugar da página, mesmo escondido (menu recolhido). */
  existe(alvo: string): boolean;
  /** Tem área na tela agora. */
  visivel(alvo: string): boolean;
}

export function passosDoTour(dom: DomTour, passos: PassoTour[] = PASSOS_TOUR): PassoTour[] {
  return passos.filter((p) => !p.opcional || p.alvos.some((a) => dom.existe(a)));
}

export type ResolucaoTour = { alvo: string; menu: 'manter' } | { alvo: null; menu: 'abrir' | 'fechar' | 'manter' };

/**
 * Onde o passo aparece. `menu: 'abrir'`/`'fechar'` pede para mexer na gaveta e resolver de novo;
 * `alvo: null` com `'manter'` mostra o passo centralizado, sem âncora (nunca some).
 */
export function resolverPasso(p: PassoTour, dom: DomTour, menuAberto: boolean): ResolucaoTour {
  if (!p.noMenu && menuAberto) return { alvo: null, menu: 'fechar' };
  const visivel = p.alvos.find((a) => dom.visivel(a));
  if (visivel) return { alvo: visivel, menu: 'manter' };
  if (p.noMenu && !menuAberto) return { alvo: null, menu: 'abrir' };
  return { alvo: null, menu: 'manter' };
}
